import IRANSansXDemiBold from '../../../assets/font/IRANSansXDemiBold.ttf';
import { Document, Page, Text, StyleSheet, Font, View, pdf,Image } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { useIntl } from "react-intl";
import moment from "moment-jalaali";

// ثبت فونت
Font.register({
  family: 'IRANSansXDemiBold',
  src: IRANSansXDemiBold,
});

const MyDocument = ({ 
  Records, 
  BelanceAccount, 
  dateinpage, 
  dateinpageend, 
  settings, 
  customername,
  intl
}) => {
  const isLTR = localStorage.getItem("language") === "en";
  const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontFamily: 'IRANSansXDemiBold',
    },
    header: {
      fontSize: 18,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 15,
    },
    companyInfo: {
      flexDirection: isLTR ? 'row' : 'row-reverse',
      justifyContent: 'space-between',
      marginBottom: 20,
    },
    infoColumn: {
      width: '48%',
    },
    infoText: {
      fontSize: 10,
      marginBottom: 5,
      textAlign: isLTR ? 'left' : 'right',
    },
    tableHeader: {
      flexDirection: isLTR ? 'row' : 'row-reverse',
      borderBottomWidth: 1,
      borderBottomColor: '#000',
      borderBottomStyle: 'solid',
      paddingBottom: 5,
      marginBottom: 5,
    },
    tableRow: {
      flexDirection: isLTR ? 'row' : 'row-reverse',
      marginBottom: 5,
    },
    cell: {
      fontSize: 10,
      padding: 2,
      textAlign: isLTR ? 'left' : 'right',
    },
    headerCell: {
      fontWeight: 'bold',
    },
    depositCell: {
      color: 'green',
    },
    withdrawCell: {
      color: 'red',
    },
    totalRow: {
      backgroundColor: '#f0f0f5',
      fontWeight: 'bold',
    },
  });

  const rows = [];
  let previousAccountId = null;
  let currentBalancep = 0;
  let accountTotalDepositp = 0;
  let accountTotalWithdrawp = 0;
  let No = 1;

  const date = (d) => {
    const date = moment.utc(d);
    let formattedDate = `${date.year()}-${String(date.month() + 1).padStart(2, "0")}-${String(date.date()).padStart(2, "0")}`;
    const hours = date.hours();
    const minutes = date.minutes();
    const ampm = hours >= 12 ? "pm" : "am";
    let aa = ampm;
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

    if (settings[0].date === "Persian") {
      moment.locale("fa");
      aa = hours >= 12 ? "ب.ظ" : "ق.ظ";
      formattedDate = moment.utc(d).format("jYYYY-jMM-jDD");
    } else {
      moment.locale("en");
    }

    return `${formattedDate} ${formattedHours}:${formattedMinutes} ${aa}`;
  };

  const Daterow = (d) => {
    const date = new Date(d);
    let formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    
    if (settings[0].date === "Persian") {
      moment.locale("fa");
      formattedDate = moment(d).format("jYYYY-jMM-jDD");
    } else {
      moment.locale("en");
    }

    return formattedDate;
  };

  const dateform = (d) => {
    const date = new Date(d);
    let formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    
    if (settings[0].date === "Persian") {
      moment.locale("fa");
      formattedDate = moment(d).format("jYYYY-jMM-jDD");
    } else {
      moment.locale("en");
    }
    
    return formattedDate;
  };

  Records.forEach((row, index) => {
    let firstBalance = 0;
    BelanceAccount.forEach((element) => {
      if (element.account_id === row.account_id) {
        firstBalance = parseInt(element.total);
      }
    });

    const isNewAccount = row.account.id !== previousAccountId;
    if (isNewAccount) {
      currentBalancep = 0;
      previousAccountId = row.account.id;
      No = 1;
      accountTotalDepositp = 0;
      accountTotalWithdrawp = 0;

      rows.push({
        type: 'previous-balance',
        data: [
          "0",
          Daterow(dateinpage),
          intl.formatMessage({ id: "previousBalance" }),
          row.account.type.name,
          firstBalance > 0 ? firstBalance.toString() : "0",
          firstBalance < 0 ? Math.abs(firstBalance).toString() : "0",
          firstBalance.toString(),
        ]
      });
    } else {
      No++;
    }

    let deposit = 0;
    let withdraw = 0;
    if (["deposite", "to", "com"].includes(row.type)) {
      deposit = parseInt(row.amount);
      currentBalancep += deposit;
      accountTotalDepositp += deposit;
    } else if (["withdraw", "from"].includes(row.type)) {
      withdraw = parseInt(row.amount);
      currentBalancep -= withdraw;
      accountTotalWithdrawp += withdraw;
    }

    rows.push({
      type: 'transaction',
      data: [
        No.toString(),
        Daterow(row.date_created),
        row.discription || "-",
        row.account.type.name,
        deposit.toString(),
        withdraw.toString(),
        (currentBalancep + firstBalance).toString(),
      ]
    });

    const isLastTransaction =
      index === Records.length - 1 ||
      Records[index + 1]?.account_id !== row.account_id;

    if (isLastTransaction) {
      rows.push({
        type: 'account-total',
        data: [
          intl.formatMessage(
            { id: 'balanceMessage' },
            {
              accountType: row?.account?.type?.name || '',
              date: date(dateinpageend || new Date()),
            }
          ),
          (accountTotalDepositp + (firstBalance > 0 ? firstBalance : 0)).toString(),
          (accountTotalWithdrawp + (firstBalance < 0 ? Math.abs(firstBalance) : 0)).toString(),
          (currentBalancep + firstBalance).toString(),
        ]
      });
    }
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.header}>
          {settings[0]?.company_name || "-"}
        </Text>
        
        <View style={styles.companyInfo}>
          <View style={styles.infoColumn}>
            <Text style={styles.infoText}>
              {intl.formatMessage({ id: 'address' })}: {settings[0]?.address || "-"}
            </Text>
            <Text style={styles.infoText}>
              {intl.formatMessage({ id: 'phone' })}: {settings[0]?.phone || "-"}
            </Text>
            <Text style={styles.infoText}>
              {intl.formatMessage({ id: 'customer' })}: {customername || "-"}
            </Text>
            <Text style={styles.infoText}>
              {intl.formatMessage({ id: 'from' })}: {dateinpage ? dateform(dateinpage) : "-"}
            </Text>
            <Text style={styles.infoText}>
              {intl.formatMessage({ id: 'to' })}: {dateinpageend ? dateform(dateinpageend) : "-"}
            </Text>
          </View>
         <View style={styles.infoColumn}>
  {/* اضافه کردن عکس */}
  <Image 
    style={styles.logo}
    src={settings[0]?.company_pic || null} // یا require('../../assets/logo.png')
  />
  <Text style={[styles.infoText, { textAlign: isLTR ? 'right' : 'left' }]}>
    {intl.formatMessage({ id: 'printDate' })}: {Daterow(new Date().toISOString())}
  </Text>
</View>
        </View>

        {/* Table Header */}
        <View style={styles.tableHeader}>
          <Text style={[styles.cell, styles.headerCell, { width: '10%' }]}>
            {intl.formatMessage({ id: 'No' })}
          </Text>
          <Text style={[styles.cell, styles.headerCell, { width: '13%' }]}>
            {intl.formatMessage({ id: 'date' })}
          </Text>
          <Text style={[styles.cell, styles.headerCell, { width: '25%' }]}>
            {intl.formatMessage({ id: 'description' })}
          </Text>
          <Text style={[styles.cell, styles.headerCell, { width: '15%' }]}>
            {intl.formatMessage({ id: 'Money Name' })}
          </Text>
          <Text style={[styles.cell, styles.headerCell, styles.depositCell, { width: '10%' }]}>
            {intl.formatMessage({ id: 'deposite' })}
          </Text>
          <Text style={[styles.cell, styles.headerCell, styles.withdrawCell, { width: '10%' }]}>
            {intl.formatMessage({ id: 'withdraw' })}
          </Text>
          <Text style={[styles.cell, styles.headerCell, { width: '10%' }]}>
            {intl.formatMessage({ id: 'Balance' })}
          </Text>
        </View>

        {/* Table Rows */}
        {rows.map((row, index) => {
          if (row.type === 'account-total') {
            return (
              <View key={index} style={[styles.tableRow, styles.totalRow]}>
                <Text style={[styles.cell, { width: '63%' }]}>{row.data[0]}</Text>
                <Text style={[styles.cell, styles.depositCell, { width: '10%' }]}>{row.data[1]}</Text>
                <Text style={[styles.cell, styles.withdrawCell, { width: '10%' }]}>{row.data[2]}</Text>
                <Text style={[styles.cell, { width: '10%' }]}>{row.data[3]}</Text>
              </View>
            );
          }

          return (
            <View key={index} style={styles.tableRow}>
              <Text style={[styles.cell, { width: '10%' }]}>{row.data[0]}</Text>
              <Text style={[styles.cell, { width: '13%' }]}>{row.data[1]}</Text>
              <Text style={[styles.cell, { width: '25%' }]}>{row.data[2]}</Text>
              <Text style={[styles.cell, { width: '15%' }]}>{row.data[3]}</Text>
              <Text style={[styles.cell, styles.depositCell, { width: '10%' }]}>{row.data[4]}</Text>
              <Text style={[styles.cell, styles.withdrawCell, { width: '10%' }]}>{row.data[5]}</Text>
              <Text style={[styles.cell, { width: '10%' }]}>{row.data[6]}</Text>
            </View>
          );
        })}
      </Page>
    </Document>
  );
};

export const generateFinancialReportPDF = async ({
  Records,
  BelanceAccount,
  dateinpage,
  dateinpageend,
  settings,
  customername,
  intl
}) => {
  try {
    const blob = await pdf(
      <MyDocument 
        Records={Records}
        BelanceAccount={BelanceAccount}
        dateinpage={dateinpage}
        dateinpageend={dateinpageend}
        settings={settings}
        customername={customername}
        intl={intl}
      />
    ).toBlob();

    saveAs(blob, `${intl.formatMessage({ id: 'financialReport' })}.pdf`);
    return true;
  } catch (error) {
    console.error('خطا در تولید PDF:', error);
    return false;
  }
};